import React, { useState } from 'react';
import RadarMap from '../../components/heatmap/RadarMap';
import MetricsCard from './MetricsCard';
import { ResponseLoading } from '../../components/utils/Loading';
import { useDashboardData, processFullDemosObj } from '../../hooks/metrics/esdata';

export default function ViewContent({ filter, setFilter, responseRadar, poiType }) {
  const stores =
    responseRadar && responseRadar.hasValue('heatmap')
      ? responseRadar.data.value.heatmap.stores
      : [];

  const [storeFilter, setStoreFilter] = useState({ ...filter, groupKeys: [] });
  const [storeSelected, setStoreSelected] = useState(null);
  const { responseFullDemos, responseVisits } = useDashboardData(storeFilter, {
    qVisits: true,
    qFullDemos: true
  });

  const onSelectPOI = selected => {
    storeFilter.storeKey = selected._id;
    setStoreFilter(storeFilter);
    setStoreSelected(selected);
  };

  const onSelectPanel = selected => {
    filter.storeKey = selected._id;
    filter.groupKeys = [];
    setFilter(filter);
  };

  const fullDemosObj = processFullDemosObj(responseFullDemos, responseVisits);

  return (
    <div className="view-content view-dashboard p-0 d-flex">
      <div style={{ position: 'relative', zIndex: 9999 }}>
        <ResponseLoading responses={[responseFullDemos, responseVisits, responseRadar]} />
      </div>
      <div className="col-5 mb-4 pr-0">
        <RadarMap {...{ stores }} onChange={onSelectPOI} defaultMap="ll" />
      </div>
      <div className="col-7">
        <MetricsCard
          filter={filter}
          fullDemosObj={fullDemosObj}
          storeSelected={storeSelected}
          onSelectPanel={onSelectPanel}
          poiType={poiType}
        />
      </div>
    </div>
  );
}
